import { render, staticRenderFns } from "./nfcreader.vue?vue&type=template&id=c8222a18&scoped=true&"
import script from "./nfcreader.vue?vue&type=script&lang=js&"
export * from "./nfcreader.vue?vue&type=script&lang=js&"
import style0 from "./nfcreader.vue?vue&type=style&index=0&id=c8222a18&lang=scss&scoped=true&"
import style1 from "./nfcreader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8222a18",
  null
  
)

export default component.exports